import { combineReducers } from 'redux';

import { networks } from "./networks/networks.reducers";
import { companies } from "./companies/companies.reducers";

export const management = combineReducers({
    networks,
    companies
});
